// extracted by mini-css-extract-plugin
export default {"illustration":"khj72WUj"};